module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/woods@3x_e0122a.jpg";